import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadiceComplessa = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 6" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-6",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsxs("g", {
				id: "radice-complessa",
				transform: "translate(166.666667, 250.000000)",
				strokeWidth: 28,
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-Copy",
						stroke: "#0056C1",
						x: 408.444444,
						y: 114,
						width: 194.222222,
						height: 305.333333
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-Copy-3",
						stroke: "#1973E1",
						x: 14,
						y: 14,
						width: 138.666667,
						height: 166.444444
					}),
					/* @__PURE__ */ _jsx("polyline", {
						id: "Path-Copy",
						stroke: "#424548",
						points: "27.7777778 319.009791 138.908218 486.947965 302.191106 14.6601621 640.767851 14.6601621"
					})
				]
			})]
		})
	})]
});
export default SvgRadiceComplessa;
